import type { IconButtonProps } from '@mui/material'
import { IconButton } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import type { FunctionComponent } from 'react'

const StyledIconButton = withStyles((theme) => ({
  root: {
    borderRadius: 0,
    border: 2,
    borderStyle: 'solid',
    width: 60,
    height: 60,
    padding: 0,
    '& .MuiSvgIcon-root': {
      fontSize: 'inherit',
    },
  },
}))(IconButton)

export const SimpleIconButton: FunctionComponent<
  React.PropsWithChildren<IconButtonProps>
> = ({ children, ...props }) => {
  return (
    <StyledIconButton className="focus:outline-none" {...props}>
      {children}
    </StyledIconButton>
  )
}
